import { useState, useEffect, useRef, useCallback } from 'react';
import { getManualServiceProviders } from '../services/subscriberWalletService';

export const useMedicineProviders = (currentRole) => {
  const [providers, setProviders] = useState([]);
  const [filteredProviders, setFilteredProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const providersFetchedRef = useRef(false);

  // Fetch providers
  useEffect(() => {
    if (!currentRole || providersFetchedRef.current) return;
    
    const fetchProviders = async () => {
      providersFetchedRef.current = true;
      setLoading(true);
      setError(null);
      try {
        const response = await getManualServiceProviders(currentRole, 'medicine');
        if (response && response.metadata && response.metadata.api_status === true) {
          const providersList = response.msg?.providers || [];
          setProviders(providersList);
          setFilteredProviders(providersList);
        } else {
          setError('Failed to load service providers');
          setProviders([]);
          setFilteredProviders([]);
        }
      } catch (err) {
        setError('Failed to load service providers');
        setProviders([]);
        setFilteredProviders([]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchProviders();
  }, [currentRole]);

  // Filter providers based on search text
  const filterProviders = useCallback((searchText) => {
    if (!searchText.trim()) {
      setFilteredProviders(providers);
    } else {
      const filtered = providers.filter(provider =>
        (provider.name || '').toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredProviders(filtered);
    }
  }, [providers]);

  return {
    providers,
    filteredProviders,
    loading,
    error,
    filterProviders,
    providersFetchedRef
  };
};

